import type { FC } from "react";
import type { IconCommonProps } from "@/icons/shared.ts";

export const IconFlag: FC<IconCommonProps> = ({ width, height, color }) => {
  return (
    <svg
      width={width ?? 10}
      height={height ?? 12}
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.649902 7.1499C0.649902 7.1499 1.1499 6.6499 2.6499 6.6499C4.1499 6.6499 5.1499 7.6499 6.6499 7.6499C8.1499 7.6499 8.6499 7.1499 8.6499 7.1499V1.1499C8.6499 1.1499 8.1499 1.6499 6.6499 1.6499C5.1499 1.6499 4.1499 0.649902 2.6499 0.649902C1.1499 0.649902 0.649902 1.1499 0.649902 1.1499V7.1499ZM0.649902 7.1499V10.6499"
        stroke={color ?? "white"}
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
